import attentionIcon from '../assets/images/icons/attention.png'

const ReceiptAttentionModal = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  onMouseMove
}) => {
  return (
    <>
      <style>
        {`
          @keyframes receiptAttentionPulse {
            0% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.12);
            }
            100% {
              transform: scale(1);
            }
          }
        `}
      </style>

      <img
        src={attentionIcon}
        alt="info"
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseMove={onMouseMove}
        style={{
          width: 30,
          height: 30,
          display: 'block',
          objectFit: 'contain',
          cursor: 'pointer',
          animation: 'receiptAttentionPulse 1.4s ease-in-out infinite',
          filter: 'drop-shadow(0 1px 8px rgba(0,0,0,0.40))'
        }}
      />
    </>
  )
}

export default ReceiptAttentionModal